import { useContext } from "react";
import BookingContext from "./BookingContext";

const useBookingState = () => useContext(BookingContext);

export default useBookingState;
